import axios from 'axios'
const TEST_URL = 'http://localhost:8080/api'
const TEST_ENV_URL = "https://attendance.hopedrew.co.uk/api";
const LIVE_URL = "https://careers.horburyinduct.com/api"
export default axios.create({
    baseURL: LIVE_URL,
    headers:{
        'Content-Type': 'application/json'
    }
});

